import { Component, Input, OnInit } from '@angular/core';
import { IROPS_STATUS } from '@app/enums/irops.enum';
import { boardingTime } from '@app/utils';
import {
  checkSegmentIsAffected,
  getFlightsNewInfoEstimatedDeparture,
  parseTime,
} from '@app/utils/functions/srIrops';

@Component({
    selector: 'new-flight-info-irops-rebrand',
    templateUrl: './new-flight-info-irops-rebrand.component.html',
    styleUrls: ['./new-flight-info-irops-rebrand.component.scss'],
    standalone: false
})
export class NewFlightInfoIropsRebrandComponent implements OnInit {

  @Input() segCancel: any;
  @Input() segModify: any;
  @Input() firstSegment: any;
  @Input() lastSegment: any;
  @Input() firstAfected: any;
  @Input() lastAfected: any;
  @Input() isDomestic: boolean;
  @Input() gate: string;

  statusIrops: any;
  acceptStatus = ['CKI', 'MYB', 'IN_FLIGHT', 'CLOSED'];

  constructor() { }

  ngOnInit() {
    if (this.segCancel) {
      this.statusIrops = 'Cancelled';
    } else {
      const status = this.segModify[0]?.flightsNewInfo?.status;

      this.statusIrops = status;
    }
  }

  get affectedDepartureDateTime(): string {
    return getFlightsNewInfoEstimatedDeparture(this.firstAfected);
  }

  get flightNumber() {
    let operatingCarrier;
    let operatingCode;

    if (this.segCancel) {
      operatingCarrier = this.segCancel?.operatingCarrier;
      operatingCode = parseInt(this.segCancel?.operatingFlightCode);
    } else {
      operatingCarrier = this.firstAfected?.operatingCarrier;
      operatingCode = parseInt(this.firstAfected?.operatingFlightCode);
    }

    return `${operatingCarrier} ${operatingCode}`;
  }

  get timeAfected() {
    if (this.segCancel) {
      return parseTime(this.segCancel?.departureDateTime, this.segCancel?.arrivalDateTime);
    } else {
      return parseTime(
        checkSegmentIsAffected(this.firstSegment) &&
        (this.firstSegment?.flightsNewInfo?.status == IROPS_STATUS.EARLY ||
          this.firstSegment?.flightsNewInfo?.status == IROPS_STATUS.DELAYED)
          ? getFlightsNewInfoEstimatedDeparture(this.firstSegment)
          : getFlightsNewInfoEstimatedDeparture(this.firstAfected),
        checkSegmentIsAffected(this.lastSegment) ? this.lastSegment?.flightsNewInfo?.arrivalDateTime : this.lastAfected?.flightsNewInfo?.arrivalDateTime
      );
    }
  }

  get boardingTime() {
    if (this.segCancel) {
      return boardingTime(this.segCancel?.departureDateTime, this.isDomestic).toDate()
    } else {
      return boardingTime(
        checkSegmentIsAffected(this.firstSegment) &&
        (this.firstSegment?.flightsNewInfo?.status == IROPS_STATUS.EARLY ||
          this.firstSegment?.flightsNewInfo?.status == IROPS_STATUS.DELAYED)
          ? getFlightsNewInfoEstimatedDeparture(this.firstSegment)
          : getFlightsNewInfoEstimatedDeparture(this.firstAfected),
        this.isDomestic
      ).toDate();
    }
  }

}
